import { VFileInput } from 'vuetify/lib/components/VFileInput';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VFileInput,{attrs:{"label":"Select File","accept":".xls,.xlsx"},on:{"change":function($event){return _vm.getJsonData()}},model:{value:(_vm.selectedFile),callback:function ($$v) {_vm.selectedFile=$$v},expression:"selectedFile"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }